/* lua.js generated code 0.3.0 */

ResourceConfig = table(
    [1, 'preloadScene', [
        "cocos/loading_panel.plist",
        "font/berlinsansfb_30_bluestroke.fnt",
    ]],
    [1, "plist", table(
        "packed/plist.pack",
    )],
    [1, "homeExtCsb", table()],
    [1, "homeExtFnt", table(
        "font/berlinsansfb_30_bluestroke.fnt"
    )],
    [1, "asyncPlist", table()],

    [1, "textList", table(
        "packed/text.pack"
    )],


    [1, "levelExtPlist", table(
        "packed/levelExtPlist.pack"
    )],

    [1, "levelExtPng", table()],

    [1, "levelExtCsb", table(
        "packed/levelComCsb.pack"
    )],
    [1, "levelExtFnt", table(
        "packed/LevelExtFnt.pack",
        "font/zzgftongxin_40_greenstroke.fnt"
    )],
    [1, "json", table(
        "config/goods.json",
        "config/product_wechatgame.json",
        // "meta/preloadResourceConfig.json",
        "config/level_extend.json"
    )],
    [1, "skeleton", table()],
    [1, "sfx", table()],
    [1, "mp3", table()], //"music/sound.WorldSceneBGM.mp3"
    [1, "homejson", table()],
    [1, "tt", table(
        "packed/ttSideHint.pack"
    )]
)
ResourceConfigPixelFormat = table()
ResourceConfigPixelFormat["materials/trunkRoot.plist"] = cc.TEXTURE2_D_PIXEL_FORMAT_RG_B565
ResourceConfigPixelFormat["materials/logo.plist"] = cc.TEXTURE2_D_PIXEL_FORMAT_RG_B565
ResourceConfigPixelFormat["materials/trunkRootBackCloud.plist"] = cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A4444
ResourceConfigPixelFormat["materials/fruitTree.plist"] = cc.TEXTURE2_D_PIXEL_FORMAT_RG_B565
ResourceConfigPixelFormat["flash/tile_select.plist"] = cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A4444
ResourceConfigPixelFormat["flash/link_item.plist"] = cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A4444
ResourceConfigPixelFormat["flash/coin.plist"] = cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A4444
ResourceConfigPixelFormat["flash/mapLock.plist"] = cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A4444
ResourceConfigPixelFormat["flash/scenes/homeScene/home.plist"] = cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A4444
ResourceConfigPixelFormat["flash/sand_move.plist"] = cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A4444
ResourceConfigPixelFormat["flash/destroy_effect.plist"] = cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A4444
ResourceFntPixelFormat = table()
ResourceArmaturePixelFormat = table()
ResourceArmaturePixelFormat["skeleton/timeback_animation"] = cc.TEXTURE2_D_PIXEL_FORMAT_RGB_A4444
ResourceConfigTextureParam = table()
ResourceConfigTextureParam["materials/home_color.plist"] = true
PanelConfigFiles = table()
PanelConfigFiles.common_ui = "ui/common_ui.json"
PanelConfigFiles.properties = "cocos/properties.json"
PanelConfigFiles.panel_game_start = "ui/panel_game_start.json"
PanelConfigFiles.third_pay_guide_panel = "ui/third_pay_guide_panel.json"
UICsbConfigFiles = table()
UICsbConfigFiles.kEnergyBtn = "cocos/homeScene_newEnergyButton.csb"
UICsbConfigFiles.kShakeBtn = "cocos/homeScene_shake_icon.csb"
UICsbConfigFiles.preLoadingUI = "cocos/preloadScene_rawUI.csb"
UICsbConfigFiles.kShakeScene = "cocos/shake_ui_ShakeMachine.csb"
